import React, { useState } from 'react';

interface StatusReasonModalProps {
    isOpen: boolean;
    title: string;
    actionLabel: string;
    /** quando true, o motivo é obrigatório (desativação) */
    reasonRequired?: boolean;
    onCancel: () => void;
    onConfirm: (reason: string) => void;
}

const StatusReasonModal: React.FC<StatusReasonModalProps> = ({
    isOpen,
    title,
    actionLabel,
    reasonRequired = true,
    onCancel,
    onConfirm,
}) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const confirm = () => {
        if (reasonRequired && !reason.trim()) {
            setError('Informe o motivo / intenção.');
            return;
        }
        onConfirm(reason.trim());
        setReason('');
        setError('');
    };

    const cancel = () => {
        setReason('');
        setError('');
        onCancel();
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000]">
            <div className="bg-white dark:bg-slate-800 rounded-lg w-[480px] max-w-[90vw] shadow-xl">
                <div className="px-5 py-3 border-b border-gray-200 dark:border-slate-700">
                    <h3 className="text-base font-semibold text-gray-700 dark:text-gray-100">{title}</h3>
                </div>
                <div className="p-5">
                    <label className="block text-sm text-gray-600 dark:text-gray-300 mb-2">
                        Motivo / intenção {reasonRequired && <span className="text-red-500">*</span>}
                    </label>
                    <textarea
                        className="w-full border border-gray-300 dark:border-slate-600 rounded-md p-2 text-sm dark:bg-slate-900 dark:text-gray-100"
                        rows={4}
                        value={reason}
                        onChange={(e) => {
                            setReason(e.target.value);
                            if (error) setError('');
                        }}
                        placeholder="Descreva o motivo desta ação..."
                    />
                    {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
                </div>
                <div className="px-5 py-3 border-t border-gray-200 dark:border-slate-700 flex justify-end gap-3">
                    <button
                        className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 dark:bg-slate-700 dark:text-gray-100"
                        onClick={cancel}
                    >
                        Cancelar
                    </button>
                    <button
                        className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
                        onClick={confirm}
                    >
                        {actionLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StatusReasonModal;
